namespace GeniuzPOS.PosShift {
    export interface PsEndDayCashierRow {
        Id?: number;
        StartShift?: number;
        EndShift?: number;
        CashierId?: string;
        ShopId?: string;
        CreateDate?: string;
        CashBag?: number;
        StartCountId?: number;
        EndCountId?: number;
        Amt?: number;
    }

    export namespace PsEndDayCashierRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CashierId';
        export const localTextPrefix = 'PosShift.PsEndDayCashier';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            StartShift = "StartShift",
            EndShift = "EndShift",
            CashierId = "CashierId",
            ShopId = "ShopId",
            CreateDate = "CreateDate",
            CashBag = "CashBag",
            StartCountId = "StartCountId",
            EndCountId = "EndCountId",
            Amt = "Amt"
        }
    }
}
